export default __webpack_public_path__ + "static/media/apple-btn.e12a2958.svg";